const GraphQLForm = require('app/graphql/Form');

class Form extends GraphQLForm {

    defaultOptions(){
        var options = {
            'mutationType': 'SubmitRestaurantSepa',
            'restaurant': null,
            'sepa': {},
        };
        return Object.assign(super.defaultOptions(),options);
    }

    initialize() {
        var self = this;

        this.restaurant = this.settings.restaurant;
        this.sepa = this.settings.sepa;

        this.buildForm();

        super.initialize();
    }

    getRestaurant(){
        return this.restaurant;
    }

    getForm(){
        return this.$form;
    }

    buildForm(){

        this.$btnSubmit = $('<button/>')
        .attr('type','submit')
        .addClass('btn btn-success')
        .append(window.translate('app.restaurant.show.tabs.info.infosForm.submit.label'));

        this.$form = $('<form/>')
        .addClass('restaurant-info-form')
        .addClass('white-box')
        .append(this.buildInputs())
        .append(
            $('<div/>')
            .append(this.$btnSubmit)
        );

        return this.$form;
    }

    buildInputs(){

        let $box = $('<div/>');

        //FIELD companyName
        let $companyNameLabel = $('<label/>')
        .attr('for','companyName')
        .append(window.translate('app.restaurant.show.tabs.sepa.form.companyName.label'));
        let $companyNameInput = $('<input/>')
        .attr('type','text')
        .attr('name','companyName')
        .addClass('form-control')
        .val(this.sepa.companyName);
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($companyNameLabel)
            .append($companyNameInput)
        );

        //FIELD address
        let $addressLabel = $('<label/>')
        .attr('for','address')
        .append(window.translate('app.restaurant.show.tabs.sepa.form.address.label'));
        let $addressInput = $('<input/>')
        .attr('type','text')
        .attr('name','address')
        .addClass('form-control')
        .val(this.sepa.address);
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($addressLabel)
            .append($addressInput)
        );

        //FIELD zipCode
        let $zipCodeLabel = $('<label/>')
        .attr('for','zipCode')
        .append(window.translate('app.restaurant.show.tabs.sepa.form.zipCode.label'));
        let $zipCodeInput = $('<input/>')
        .attr('type','text')
        .attr('name','zipCode')
        .addClass('form-control')
        .val(this.sepa.zipCode);
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($zipCodeLabel)
            .append($zipCodeInput)
        );

        //FIELD city
        let $cityLabel = $('<label/>')
        .attr('for','city')
        .append(window.translate('app.restaurant.show.tabs.sepa.form.city.label'));
        let $cityInput = $('<input/>')
        .attr('type','text')
        .attr('name','city')
        .addClass('form-control')
        .val(this.sepa.city);
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($cityLabel)
            .append($cityInput)
        );

        //FIELD bic
        let $bicLabel = $('<label/>')
        .attr('for','bic')
        .append(window.translate('app.restaurant.show.tabs.sepa.form.bic.label'));
        let $bicInput = $('<input/>')
        .attr('type','text')
        .attr('name','bic')
        .addClass('form-control')
        .val(this.sepa.bic);
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($bicLabel)
            .append($bicInput)
        );

        //FIELD iban
        let $ibanLabel = $('<label/>')
        .attr('for','iban')
        .append(window.translate('app.restaurant.show.tabs.sepa.form.iban.label'));
        let $ibanInput = $('<input/>')
        .attr('type','text')
        .attr('name','iban')
        .addClass('form-control')
        .val(this.sepa.iban);
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($ibanLabel)
            .append($ibanInput)
        );

        //FIELD rum
        let $rumLabel = $('<label/>')
        .attr('for','rum')
        .append(window.translate('app.restaurant.show.tabs.sepa.form.rum.label'));
        let $rumInput = $('<input/>')
        .attr('type','text')
        .attr('name','rum')
        .addClass('form-control')
        .val(this.sepa.rum);
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($rumLabel)
            .append($rumInput)
        );

        //FIELD signatureCity
        let $signatureCityLabel = $('<label/>')
        .attr('for','signatureCity')
        .append(window.translate('app.restaurant.show.tabs.sepa.form.signatureCity.label'));
        let $signatureCityInput = $('<input/>')
        .attr('type','text')
        .attr('name','signatureCity')
        .addClass('form-control')
        .val(this.sepa.signatureCity);
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($signatureCityLabel)
            .append($signatureCityInput)
        );


        //FIELD signedAt
        let signedAt = '';
        let date = moment(this.sepa.signedAt);
        if(date){
            signedAt = date.format('YYYY-MM-DD');
        }
        let $signedAtLabel = $('<label/>')
        .attr('for','signedAt')
        .append(window.translate('app.restaurant.show.tabs.sepa.form.signedAt.label'));
        let $signedAtInput = $('<input/>')
        .attr('type','date')
        .attr('name','signedAt')
        .addClass('form-control')
        .val(signedAt);
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($signedAtLabel)
            .append($signedAtInput)
        );

        return $box;
    }

    onDOMReady(){
        super.onDOMReady();
    }

    getFields(){
        let fields = super.getFields();
        fields.push('sepa { restaurant { id } }');
        return fields;
    }
    
    getVariables(){
        let variables = {};

        variables.restaurant = {
            'value': this.restaurant.id,
            'type': 'Int!'
        };

        return variables;
    }


}

module.exports = Form;

